const DEFAULT_CURRENCY: string = "USD";

export { DEFAULT_CURRENCY };
